import React from 'react';
import { WorkoutData } from '../types/workout';
import { UserProfile } from '../types/user';
import { UserPowerProfile } from '../types/userProfile';
import { generateSVG, generateWorkoutHeader } from '../utils/svgGenerator';
import styles from './WorkoutChart.module.css';

interface WorkoutChartProps {
    workoutData: WorkoutData;
    userProfile?: UserProfile | UserPowerProfile;
    width?: number;
    height?: number;
    showMetrics?: boolean;
}

const WorkoutChart: React.FC<WorkoutChartProps> = ({ 
    workoutData, 
    userProfile,
    width = 800, 
    height = 200,
    showMetrics = false
}) => {
    const svgWidth = 3057;
    const svgHeight = 370.7;
    
    return (
        <div className={styles.container} style={{ height: height }}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 3057 370.7"
                preserveAspectRatio="xMidYMid meet"
                shapeRendering="crispedges"
                className={styles.svg}
            >
                {/* Background first */}
                <rect
                    x={0}
                    y={0}
                    width={svgWidth}
                    height={svgHeight}
                    className={styles.background}
                />
                {/* Chart elements (without background) */}
                {generateSVG(workoutData, userProfile, showMetrics)}
                {/* Header elements on top */}
                {generateWorkoutHeader(workoutData, userProfile, showMetrics)}
            </svg>
        </div>
    );
};

export default WorkoutChart;